// Generated by ReScript, PLEASE EDIT WITH CARE


var dummyResponse = {
    "exists": true,
  };

export {
  dummyResponse ,
}
/* No side effect */
